import { Link, useParams } from "react-router-dom";
import { Hammer, ArrowLeft } from "lucide-react";
import { ClientShell, useClientUser } from "@/pages/client/ClientShell";

const TITLES = { demat: "Demat Details", documents: "Documents", notifications: "Notifications", support: "Support", orders: "My Orders", kyc: "KYC" };

export default function ClientComingSoon() {
  const user = useClientUser();
  const { module } = useParams();
  if (!user) return null;
  const title = TITLES[module] || "This section";
  return (
    <ClientShell user={user} title={title}>
      <div data-testid="client-coming-soon" className="mt-8 flex flex-col items-center border border-dashed border-slate-300 bg-[#F6F4FD]/60 px-6 py-16 text-center">
        <Hammer className="h-6 w-6 text-[#6D28D9]" />
        <p className="font-display mt-4 text-xl font-semibold text-slate-900">Coming soon</p>
        <p className="mt-2 max-w-md text-sm text-slate-500">{title} is being prepared for your portal. Until then, our desk can help on WhatsApp at +91 81696 47280.</p>
        <Link data-testid="client-back-dashboard" to="/client/dashboard" className="mt-8 inline-flex items-center gap-2 bg-[#6D28D9] px-6 py-3 font-mono2 text-[11px] font-semibold uppercase tracking-[0.2em] text-white hover:bg-[#5B21B6]"><ArrowLeft className="h-3.5 w-3.5" /> Back to dashboard</Link>
      </div>
    </ClientShell>
  );
}
